import React from "react";
import button from "reactstrap";




const Banner = (props) => {

    const classname = (props.IsSuccess) ? 'alert-success fade show' : 'alert alert-danger alert-dismissible fade show'; 

    return (
        <div className={classname}>
            {props.message}
            <button type="button" onClick={()=>props.Close()} className="close" data-dismiss="alert">&times;</button>
        </div>
        );
}

export default Banner;